import { Dispatcher } from 'flux';
import keyMirror from 'keymirror';
import assign from 'object-assign';

var PayloadSources = keyMirror({
    SERVER_ACTION: null,
    VIEW_ACTION: null
});

var ApplicationDispatcher = assign(new Dispatcher(), {
    handleServerAction: function (action) {
        // console.log('SERVER: %s', action.actionType);
        var payload = {
            source: PayloadSources.SERVER_ACTION,
            action: action
        };
        this.dispatch(payload);
    },

    handleViewAction: function (action) {
        // console.log('VIEW: %s', action.actionType);
        var payload = {
            source: PayloadSources.VIEW_ACTION,
            action: action
        };

        this.dispatch(payload);
    }
})

export default ApplicationDispatcher;
